/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { AdminTermDto, AdminTermRequestDto } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class AdminTermService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags AdminTermService
   * @name GetTermByCategory1
   * @summary Get Term by Category
   * @request GET:/v1/admin/terms/{category}
   * @secure
   */
  getTermByCategory1 = (
    category:
      | 'PRIVACY_POLICY'
      | 'FACILITY_USAGE_POLICY'
      | 'THIRD_PARTY_PRIVACY_POLICY'
      | 'MARKETING_AGREEMENT'
      | 'RESERVATION'
      | 'CHECKIN'
      | 'USAGE',
    params: RequestParams = {},
  ) =>
    this.http.request<AdminTermDto, any>({
      path: `/v1/admin/terms/${category}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminTermService
   * @name SaveTerm
   * @summary Save Term
   * @request POST:/v1/admin/terms/{category}
   * @secure
   */
  saveTerm = (
    category:
      | 'PRIVACY_POLICY'
      | 'FACILITY_USAGE_POLICY'
      | 'THIRD_PARTY_PRIVACY_POLICY'
      | 'MARKETING_AGREEMENT'
      | 'RESERVATION'
      | 'CHECKIN'
      | 'USAGE',
    data: AdminTermRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<AdminTermDto, any>({
      path: `/v1/admin/terms/${category}`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminTermService
   * @name DeleteTerm
   * @summary Delete Term
   * @request DELETE:/v1/admin/terms/{category}
   * @secure
   */
  deleteTerm = (
    category:
      | 'PRIVACY_POLICY'
      | 'FACILITY_USAGE_POLICY'
      | 'THIRD_PARTY_PRIVACY_POLICY'
      | 'MARKETING_AGREEMENT'
      | 'RESERVATION'
      | 'CHECKIN'
      | 'USAGE',
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/admin/terms/${category}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
}
